// Λίστα ανακληθέντων προϊόντων (Google Merchant Center flag: "Ανακληθέν
// προϊόν"). Τα ps_id που περιλαμβάνονται εδώ:
//  - εξαιρούνται από το merchant-feed & local-inventory-feed
//  - εξαιρούνται από το sitemap.xml
//  - παίρνουν noindex,follow στη σελίδα προϊόντος
//
// Ενημέρωσε τη λίστα προσθέτοντας το ps_id όταν λάβεις ειδοποίηση
// ανάκλησης από τον κατασκευαστή ή από αρχή (ΕΦΕΤ, RAPEX κ.λπ.).
export const RECALLED_PS_IDS: ReadonlySet<number> = new Set<number>([
  42476, 7068, 3421, 1464, 3762,
]);

export function isRecalled(psId: number | null | undefined): boolean {
  return psId != null && RECALLED_PS_IDS.has(Number(psId));
}